// Centralised dashboard IDs file
// Standardized for Social Impact Intelligence focusing.

// Active Dashboard IDs
export const social_impact_intelligence_dashboard_id = '589185cb-5f4b-4d41-95ed-69b4c05785a2';
export const employee_volunteerism_engagement_dashboard_id = 'fe463653-fbbd-4bb6-87fc-e77ce76f780f';
export const stakeholder_community_feedback_dashboard_id = 'd9e37d39-72ce-49ea-ae95-2a575772bfde';

// Standby Dashboard IDs (Placeholders)
export const enterprise_supplier_development_dashboard_id = 'standby-id';
export const esd_compliance_dashboard_id = '399ab253-251b-4d26-92cf-ff0983d2f5c7';
export const esd_programmes_delivery_dashboard_id = 'f7d41a8a-07df-49e4-ac53-38b3d9d5d680';
export const esd_social_impact_dashboard_id = '5a9d6530-7c65-42f9-a11d-f3a25d0bb154';

export const skills_development_youth_employment_dashboard_id = 'standby-id';
export const sdye_compliance_dashboard_id = '028f0f4e-00d4-4220-8265-7e5ff653228e';
export const sdye_programmes_delivery_dashboard_id = '642c8c5d-3634-4dea-bf9d-ac13b1c831fc';
export const sdye_social_impact_dashboard_id = 'a192b2d1-c092-49bb-b54a-4c9a8149441f';

export const socio_economic_development_dashboard_id = 'standby-id';
export const sed_compliance_dashboard_id = 'f2d2be91-006a-43ae-ae10-15454d6cdcbb';
export const sed_programmes_delivery_dashboard_id = '52412a8c-6281-416d-8c5b-9b07f53a4ba3';
export const sed_social_impact_dashboard_id = '96aa338d-db35-4cea-bf30-c1dd0c47fec8';

export const impact_exchange_rate_engine_dashboard_id = 'standby-id';
export const fund_performance_capital_recycling_dashboard_id = 'standby-id';
export const real_time_operations_asset_control_dashboard_id = 'standby-id';

// Default main dashboard
export const main_dashboard_id = social_impact_intelligence_dashboard_id;

// Role-based global dashboard mappings (per sidebar nav key)
const standardized_mapping = {
  default: social_impact_intelligence_dashboard_id,
  'social_impact_intelligence': social_impact_intelligence_dashboard_id,
  'employee_volunteerism_engagement': employee_volunteerism_engagement_dashboard_id,
  'stakeholder_community_feedback': stakeholder_community_feedback_dashboard_id,
  
  // ESD
  'enterprise_supplier_development': enterprise_supplier_development_dashboard_id,
  'esd_compliance': esd_compliance_dashboard_id,
  'esd_programmes_delivery': esd_programmes_delivery_dashboard_id,
  'esd_social_impact': esd_social_impact_dashboard_id,
  
  // SDYE
  'skills_development_youth_employment': skills_development_youth_employment_dashboard_id,
  'sdye_compliance': sdye_compliance_dashboard_id,
  'sdye_programmes_delivery': sdye_programmes_delivery_dashboard_id,
  'sdye_social_impact': sdye_social_impact_dashboard_id,
  
  // SED
  'socio_economic_development': socio_economic_development_dashboard_id,
  'sed_compliance': sed_compliance_dashboard_id,
  'sed_programmes_delivery': sed_programmes_delivery_dashboard_id,
  'sed_social_impact': sed_social_impact_dashboard_id,
  
  // Others
  'impact_exchange_rate_engine': impact_exchange_rate_engine_dashboard_id,
  'fund_performance_capital_recycling': fund_performance_capital_recycling_dashboard_id,
  'real_time_operations_asset_control': real_time_operations_asset_control_dashboard_id
};

export const role_dashboards = {
  admin: standardized_mapping,
  fund_manager: standardized_mapping,
  donor: standardized_mapping,
  governance: standardized_mapping,
  entrepreneur: standardized_mapping
};
